<template>
  <div class="disable-user-container">
    <div class="title">{{ $t('DisableUser') }}</div>
    <div class="content">{{ $t('chooseUserReplacement') }}</div>
    <div class="form-container">
      <Dropdown
        :config="{ inputSize: 40, color: 'white', active: false }"
        :values="users"
        :placeholder="$t('chooseNewManager')"
        :on-change="value => (manager = value.id)"
        :value="manager"
      >
        <template #placeholder="{ value, isPlaceholder }">
          <div v-if="!isPlaceholder" class="manager">{{ getManagerInfos.firstName }} {{ getManagerInfos.lastName }}</div>
          <div v-else class="manager grey">{{ value }}</div>
        </template>
        <template #choices="{ choice }">
          <div class="manager white" :class="{ highlight: choice === manager }">{{ choice.firstName }} {{ choice.lastName }}</div>
        </template>
      </Dropdown>
    </div>
    <div class="choices">
      <div class="cancel main-button" @click.stop="popupResolve({ value: false, manager })">{{ $t('cancel') }}</div>
      <div class="submit main-button" @click.stop="popupResolve({ value: true, manager })">{{ $t('confirm') }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Dropdown from '@/components/Dropdown';

export default {
  components: { Dropdown },

  data() {
    return {
      manager: '',
      users: [],
    };
  },

  computed: {
    ...mapGetters(['popupData', 'popupResolve', 'popupReject']),

    getManagerInfos() {
      const info = this.users.find(value => value.id === this.manager);
      return info;
    },
  },

  async mounted() {
    this.users = (await this.$store.dispatch('getUsers', { id: this.popupData.companyId })).users;
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
* {
  box-sizing: border-box;
}

.disable-user-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 380px;

  .form-container {
    margin-top: 24px;
  }

  .title {
    color: colors.$darkblue-color;
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .content {
    color: colors.$darkgrey-color;
    font-size: 14px;
    opacity: 0.8;

    .bold {
      font-weight: 500;
    }
  }

  .choices {
    margin-top: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .main-button {
      margin: 0 12px 0;
      min-width: 135px;
      width: 135px;
      height: 40px;
      padding: 0;
      font-weight: 400;
    }

    .cancel {
      margin: 0 12px 0 0;
      background: colors.$lightgrey-color;
      color: colors.$darkgrey-color;
    }
  }
}
</style>
